module.exports = __webpack_public_path__ + "static/media/icon-filters.cd82fd3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-filters.svg
// module id = 1722
// module chunks = 0